import { GroupOrderJoinScreen } from '../../../../screens/GroupOrderJoinScreen';

// ─────────────────────────────────────────────────────────────────────────────

export default function GroupOrderJoinRoute() {
  return <GroupOrderJoinScreen />;
}
